export const WORKFLOW_UI_IDENTIFIER = {
  ENTITY_LAYOUT: 'ENTITY_LAYOUT',
  ENTITY_LAYOUT_LIST: 'ENTITY_LAYOUT_LIST',
  SEND_COMMUNICATION_FAX: 'SEND_COMMUNICATION_FAX',
  AUTO_SEND_COMMUNICATION_FAX: 'AUTO_SEND_COMMUNICATION_FAX',
  AUTO_SEND_COMMUNICATION_SMS: 'AUTO_SEND_COMMUNICATION_SMS',
  RE_VALIDATE: 'RE_VALIDATE',
  NEW_CASE_HYPERLINK: 'NEW_CASE_HYPERLINK',
  NO_PREVIEW: 'NO_PREVIEW',
  PROVIDER_SIGNATURE: 'PROVIDER_SIGNATURE',
  PATIENT_SIGNATURE: 'PATIENT_SIGNATURE',
  WORKFLOW_SUMMARY_TASK: 'WORKFLOW_SUMMARY_TASK',
  FAX_OUTBOUND_TASK: 'FAX_OUTBOUND_TASK',
  MAIL_OUTBOUND_TASK: 'MAIL_OUTBOUND_TASK',
  GENERATE_DOCUMENT: 'GENERATE_DOCUMENT',
  CUSTOM_ENROLLMENT_LAYOUT: 'CUSTOM_ENROLLMENT_LAYOUT',
  CALL_OUTBOUND_TASK: 'CALL_OUTBOUND',
  MANUAL_CALL_OUTBOUND: 'MANUAL_CALL_OUTBOUND',
  SYSTEM_CALL_OUTBOUND: 'SYSTEM_CALL_OUTBOUND',
  SYSTEM_MAIL_OUTBOUND: 'SYSTEM_MAIL_OUTBOUND',
  MANUAL_MAIL_OUTBOUND: 'MANUAL_MAIL_OUTBOUND',
  PRT_ERP: 'PRT_ERP',
  CUSTOM_ELIGIBILITY_LAYOUT: 'CUSTOM_ELIGIBILITY_LAYOUT',
  CUSTOM_LAYOUT_SCREEN: 'CUSTOM_LAYOUT_SCREEN',
  PAP_EXCEPTION_REVIEW_TASK: 'PAP_EXCEPTION_REVIEW_TASK',
  PAP_EXECPTION_REVIEW_SUB_UI_IDENTIFIER:
    'PAP_EXCEPTION_REVIEW_SUB_UI_IDENTIFIER',
  GET_MAXRTE: 'GET_MAXRTE',
  CUSTOM_ENTITY_LAYOUT_TASK: 'CUSTOM_ENTITY_LAYOUT_TASK',
  GET_E_INCOME: 'GET_E_INCOME',
  PAP_E_INCOME_TASK: 'PAP_E_INCOME_TASK',
  PTR_CAPTURE_PHARMACY_DETAILS: 'PTR_CAPTURE_PHARMACY_DETAILS',
  DOCUMENT_PREVIEW_TASK: 'DOCUMENT_PREVIEW_TASK',
  PAP_CAPTURE_API_RESPONSE: 'PAP_CAPTURE_API_RESPONSE',
  C_PAP_ACCESS_ELIGIBILITY: 'C_PAP_ACCESS_ELIGIBILITY',
  VOUCHER_ACCESS_ELIGIBILITY: 'VOUCHER_ACCESS_ELIGIBILITY',
  PAP_APPEAL_REVIEW_TASK: 'PAP_APPEAL_REVIEW_TASK',
  WITHDRAW_ENROLLMENT_TASK: 'WITHDRAW_ENROLLMENT_TASK',
  MANUAL_TEXT_OUTBOUND: 'MANUAL_TEXT_OUTBOUND',
  PAP_SEND_COMMUNICATION_FAX: 'PAP_SEND_COMMUNICATION_FAX',
  NOVO_PAP_ORDER_LISTING_LAYOUT_TASK: 'NOVO_PAP_ORDER_LISTING_LAYOUT_TASK',
  NOVO_PAP_E_INCOME_TASK_SUB_UI_IDENTIFIER:
    'NOVO_PAP_E_INCOME_TASK_SUB_UI_IDENTIFIER',
  MEDICAL_EXPENSE: 'MEDICAL_EXPENSE',
  NOVO_PAP_VOUCHER_LAYOUT_TASK: 'NOVO_PAP_VOUCHER_LAYOUT_TASK',
}

export const PHARMACY_RE_TRIAGE_UI_IDENTIFIER = {
  PTR_QUEUED_DATE: 'PTR_QUEUED_DATE',
  PTR_ELIGIBILITY_ASSESSMENT: 'PTR_ELIGIBILITY_ASSESSMENT',
}

export const FILTER_KEYS = {
  DO_NOT_USE: 'Do Not Use',
}

export const TASK_TYPE_IDS = {
  MANUAL_TEXT_OUTBOUND: 50,
} as const
